import i18n from "i18next";

export const getCurrentLanguage = () => {
  return i18n.language || "en";
};
